import apps from "@services/applications";
import { RouteLocation } from "vue-router";

export default [
  {
    path: "/app/import",
    name: "import",
    meta: {
      module: "imports",
      title: "Imports"
    },
    component: () => import("@Imports/views/GeneralImports.vue"),
    children: [
      {
        path: ":type/:id?",
        name: "create-import",
        meta: {
          application: function (route: RouteLocation) {
            const appName = route.params.type as string;
            return apps["Imports"][appName]?.Id;
          },
          authenticatedRoute: true
        },
        component: () => import("@Imports/components/CreateImport.vue")
      },
      {
        path: "progress/:type/:id",
        name: "progress-import",
        meta: {
          authenticatedRoute: true
        },
        component: () => import("@Imports/components/ProgressImport.vue")
      }
    ]
  }
];
